import { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { API_URL } from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";

import HotelChangesForm from "../Admin/Hotel/HotelChangesForm";

import HotelCsvNav from "./HotelCsvNav";

import Nav from "./Nav";

const Hotelcsv = () => {
	const [details, setDetails] = useState({});
	const [changes, setChanges] = useState([]);
	const [changes2, setChanges2] = useState([]);
	const [, setErrors] = useState([]);
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const { str } = useParams();
	const history = useHistory();

	useEffect(() => {
		const init = async () => {
			const url = new URL(`${API_URL}/hotelcsvChangesInit`);
			const params = {
				id: str ? str : "",
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setDetails({ ...json });
					setChanges(json.pendingChanges);
					setChanges2(json.pendingChanges2);
					setAlert({});
				} else {
					setAlert({
						type: "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();

		// eslint-disable-next-line
	}, []);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/admin/hotelChanges`);
		let data = new FormData(document.getElementById("changes-form"));
		data.append("token", details.token);

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				history.push({
					pathname: `/hotelcsv/${str}`,
					state: {
						message: {
							type: "success",
							text: json.text,
						},
					},
				});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			{alert.type === "working" ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Hotel Report & Changes Admin" />
						<HotelCsvNav selected="changes" str={str} />
						<HotelChangesForm
							changes={changes}
							changes2={changes2}
							msg={msg}
							submit={handleSubmit}
						/>

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Nav fname={details.fname} />
					</div>
				</>
			)}
		</>
	);
};

export default Hotelcsv;
